var _ = require('underscore');

angular.module('am4').factory('syncReport', function($translate, orgFacService, viewableMachines, appCacheService, $filter) {
    var facilityNameFilter = $filter('facilityName'),
        state = appCacheService.getAppCache('appState'),
        getFilterPredicate = function() {
            if (state.activeMachinesOnly && state.deleted) {
                return m => m.is_active;
            }
            if (state.activeMachinesOnly && !state.deleted) {
                return m => m.is_active && !m.is_removed;
            }
            if (!state.activeMachinesOnly && !state.deleted) {
                return m => !m.is_removed;
            }
            return () => true;
        };

    return {
        activeInactiveEquipment: function(facIds) {
            var facilityIds = appCacheService.getAppCache('appState').currentElasticOptions.facility_id;

            if (!facilityIds.length) {
                facilityIds = facIds;
            }

            return [
                {
                    key: $translate.instant('ACTIVE'),
                    values: facilityIds.map(function(id) {
                        return {
                            label: facilityNameFilter(id),
                            value: _.filter(viewableMachines(), getFilterPredicate()).map(function(machine) {
                                if (machine.facility_id === id && machine.is_active) {
                                    return 1;
                                }
                                return 0;
                            })
                            .reduce(addUp)
                        };
                    })
                },
                {
                    key: $translate.instant('INACTIVE'),
                    values: facilityIds.map(function(id) {
                        return {
                            label: facilityNameFilter(id),
                            value: _.filter(viewableMachines(), getFilterPredicate()).map(function(machine) {
                                if (machine.facility_id === id && !machine.is_active) {
                                    return 1;
                                }
                                return 0;
                            })
                            .reduce(addUp)
                        };
                    })
                }
            ];
        },
        healthyUnhealthyEquipment: function(facIds) {
            var facilityIds = appCacheService.getAppCache('appState').currentElasticOptions.facility_id;

            if (!facilityIds.length) {
                facilityIds = facIds;
            }

            return [
                {
                    key: $translate.instant('HEALTHY'),
                    values: facilityIds.map(function(id) {
                        return {
                            label: facilityNameFilter(id),
                            value: _.filter(viewableMachines(), getFilterPredicate()).map(function(machine) {
                                if (machine.facility_id === id && machine.healthy) {
                                    return 1;
                                }
                                return 0;
                            })
                            .reduce(addUp)
                        };
                    })
                },
                {
                    key: $translate.instant('UNHEALTHY'),
                    values: facilityIds.map(function(id) {
                        return {
                            label: facilityNameFilter(id),
                            value: _.filter(viewableMachines(), getFilterPredicate()).map(function(machine) {
                                if (machine.facility_id === id && !machine.healthy) {
                                    return 1;
                                }
                                return 0;
                            })
                            .reduce(addUp)
                        };
                    })
                }
            ];
        },
        errorAlertOfflineEquipment: function(facIds) {
            var facilityIds = appCacheService.getAppCache('appState').currentElasticOptions.facility_id;

            if (!facilityIds.length) {
                facilityIds = facIds;
            }

            return [
                {
                    key: $translate.instant('OFFLINE'),
                    values: facilityIds.map(function(id) {
                        return {
                            label: facilityNameFilter(id),
                            value: _.filter(viewableMachines(), getFilterPredicate()).map(function(machine) {
                                if (machine.facility_id === id && !machine.online) {
                                    return 1;
                                }
                                return 0;
                            })
                            .reduce(addUp)
                        };
                    })
                },
                {
                    key: $translate.instant('ERROR'),
                    values: facilityIds.map(function(id) {
                        return {
                            label: facilityNameFilter(id),
                            value: _.filter(viewableMachines(), getFilterPredicate()).map(function(machine) {
                                if (machine.facility_id === id && machine.error_code !== 0) {
                                    return 1;
                                }
                                return 0;
                            })
                            .reduce(addUp)
                        };
                    })
                },
                {
                    key: $translate.instant('SERVICE_REQUEST'),
                    values: facilityIds.map(function(id) {
                        return {
                            label: facilityNameFilter(id),
                            value: _.filter(viewableMachines(), getFilterPredicate()).map(function(machine) {
                                if (machine.facility_id === id) {
                                    return 1;
                                }
                                return 0;
                            })
                            .reduce(addUp)
                        };
                    })
                }
            ];
        },

        // This function should convert nvd3 multiBarChart JSON data
        // into a table à la Row[Col[]]
        //
        // EXAMPLE
        //
        // [{
        //   key: 'Active',
        //   values: [{
        //     label: 'Marquette',
        //     value: 8
        //   }, {
        //     label: 'YMCA',
        //     value: 123
        //   }]
        // }, {
        //   key: 'Inactive',
        //   values: [{
        //      label: 'Marquette',
        //      value: 0
        //   }, {
        //      label: 'YMCA',
        //      value: 22
        //   }]
        // }]
        //
        // TRANSFORMS INTO
        //
        // [['FACILITY', 'Active', 'Inactive', ...],
        // ['Marquette', 8, 0],
        // ['YMCA', 123, 22]]
        convertToPapaTabular: function(reportData) {
            var ret = [],
                // populate headers
                headers = [$translate.instant('FACILITY')],
                // populate rows (data)
                rowLen = reportData[0].values.length;

            // stream names -- aka 'Active', 'Inactive', etc.
            headers = headers.concat(reportData.map(function(stream) {
                return stream.key;
            }));

            ret.push(headers);

            for (let i = 0; i < rowLen; i++) {
                ret.push(getRow(i));
            }

            function getRow(i) {
                return [reportData[0].values[i].label].concat( // facility name
                    reportData.map(function(stream) {
                        // stream values, 8, 12, 0, etc.
                        return stream.values[i].value;
                    })
                );
            }

            return ret;
        }
    };

    function addUp(current, prev) {
        return current + prev;
    }

});



// WEBPACK FOOTER //
// ./src/app/services/syncReport.js